import CoreInstance from '../CoreInstance';
import { getHeadersWithTokens } from '../ApiHelpers';
import { localeFlag } from 'api/ApiHelpers';

const organizations = {
  // ..
};

const centers = {
  postBaby: body => CoreInstance.post('/centers/babies', body),
  getBaby: babyId => CoreInstance.get(`/centers/babies/${babyId}`, getHeadersWithTokens(true)),
  putBaby: (babyId, body) => CoreInstance.put(`/centers/babies/${babyId}`, body, getHeadersWithTokens(true)),
  getBabies: () => CoreInstance.get('/centers/babies', getHeadersWithTokens(true)),
  deleteBaby: babyId => CoreInstance.delete(`/centers/babies/${babyId}`, getHeadersWithTokens(true)),
  getBabyInitialAssessment: babyId => CoreInstance.get(`/centers/babies/${babyId}/initial_assessment`, getHeadersWithTokens(true)),
  putBabyMilestoneAnswer: (babyId, data) => CoreInstance.put(`/centers/babies/${babyId}/update_progress`, data, getHeadersWithTokens(true)),
  putResetBabyProgress: babyId => CoreInstance.put(`/centers/babies/${babyId}/reset_progress`, getHeadersWithTokens(true)),
  postAssignGroupToBaby: (babyId, body) => CoreInstance.post(`/centers/babies/${babyId}/assign_groups`, body, getHeadersWithTokens(true)),
  deleteUnassignGroupToBaby: (babyId, body) => CoreInstance.delete(`/centers/babies/${babyId}/unassign_groups`, { data: body }, getHeadersWithTokens(true)),
  putSynchronizeKineduBabyWithClassroom: (babyId, kineduBabyId) => CoreInstance.put(`/centers/babies/${babyId}/sync_kinedu_baby?kinedu_baby_id=${kineduBabyId}`, getHeadersWithTokens(true)),
  postImportProgressFromKinedu: babyId => CoreInstance.post(`/centers/babies/${babyId}/import_kinedu_progress`, getHeadersWithTokens(true)),
  postKineduBabies: emails => CoreInstance.post('/centers/kinedu_resources/babies_associated_to_email', { emails }, getHeadersWithTokens(true)),
  postParenReinvite: id => CoreInstance.post(`/centers/parents/${id}/generate_invite`, getHeadersWithTokens(true)),
  postInviteParents: body => CoreInstance.post(`/centers/parents/generate_invite?${localeFlag()}`, body, getHeadersWithTokens(true)),
  getBabyFeed: ({ babyId, page, params }) => {
    const search = params !== '' ? (`&${ params}`) : '';
    return CoreInstance.get(`/centers/babies/${babyId}/classrooms_feed_v2?page=${page}&per_page=10${search}&${localeFlag()}`, getHeadersWithTokens(true));
  },
};

export default {
  organizations,
  centers,
};
